import { useQuery } from "@tanstack/react-query";
import { api, tokenStore } from "@/lib/api";
import { STATIC_CATEGORIES } from "@/lib/utils-app";

export function useCategories() {
  const { data } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => (await api.get("/categories")).data,
    enabled: !!tokenStore.access,
  });
  return data?.length ? data : STATIC_CATEGORIES;
}
